// removed by extract-text-webpack-plugin
module.exports = {"btn-post-demand":"btn-post-demand","post-demand-text":"post-demand-text","cart-count":"cart-count","notification-item":"notification-item","notification-count":"notification-count"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_ShoppingCart.scss
// module id = ./components/layouts/master/sub-header/_ShoppingCart.scss
// module chunks = 0